/**
 * WidgetDivider - горизонтальный разделитель для виджета
 *
 * Переиспользуемый компонент-разделитель с отступами через CSS переменные.
 */

import { memo } from 'react';
import PropTypes from 'prop-types';
import './WidgetDivider.css';

export const WidgetDivider = memo(({ className = '' }) => {
  return <hr className={`widget-divider ${className}`} />;
});

WidgetDivider.displayName = 'WidgetDivider';

WidgetDivider.propTypes = {
  className: PropTypes.string,
};
